import PropTypes from 'prop-types'
import React, { useState } from 'react'
import { routerPropTypes } from 'Types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { useQuery } from '@apollo/client'
import get from 'lodash/get'
import { storeProductsResponse, storeLocation } from 'Actions'
import {
  Large,
  Small,
  Loading,
  MobileFilters,
  HelmetTitle
} from '../components'
import { generateQueryVars } from '../queries'
import { GET_PRODUCTS } from 'Queries'
import { ErrorView, JourneyTracker, FilterReduxHandler } from 'Blocks'
import { SCREEN_TYPE, PAGE_CONTEXT as p } from 'Constants'

const ProductListPage = props => {
  const [dialog, setDialog] = useState({
    isActive: false,
    activeView: null
  })

  function closeDialog() {
    setDialog({
      isActive: false,
      activeView: null
    })
  }

  function generateJourneyTrackerProps(data, isSearch) {
    const resolveBreadCrumbsName = (name, isSearch) =>
      isSearch ? 'Browse' : name
    return {
      routeName: p.PRODUCT_LIST,
      location: props.location,
      params: props.match.params,
      name: resolveBreadCrumbsName(
        data.products.categories.current.name,
        isSearch
      ),
      extra: {
        topCategories: data.products.categories.top,
        subCategories: data.products.categories.children
      }
    }
  }

  const isSearch = props.match.params.subCategory === 'search'
  const queryString = props.location.search
  const dialogViewMatch = queryString.match(/dialogView=(\w+)/)
  const screenIsSmall = props.screenType === SCREEN_TYPE.SMALL
  const dialogView = dialogViewMatch && dialogViewMatch[1] !== 'search'

  const variables = generateQueryVars(props.location, props.match.params)
  const { loading, error, data } = useQuery(GET_PRODUCTS, { variables })

  if (loading) {
    if (screenIsSmall && dialogView) {
      return (
        <MobileFilters
          {...props}
          data={data}
          queryString={queryString}
          loading={loading}
        />
      )
    }
    return <Loading pageName={p.PRODUCT_LIST} />
  }

  if (error) return <ErrorView message={error.message} error={error} />

  const categoryName = get(data, 'products.categories.current.name', '')

  return (
    <div className={`main-container ${props.className}`}>
      <HelmetTitle {...{ categoryName }} />
      <JourneyTracker {...generateJourneyTrackerProps(data, isSearch)} />
      <FilterReduxHandler
        data={data}
        url={props.location.pathname}
        queryString={queryString}
      />
      {screenIsSmall ? (
        dialogView ? (
          <MobileFilters data={data} queryString={queryString} />
        ) : (
          <Small
            dialog={dialog}
            closeDialog={closeDialog}
            data={data}
            params={props.match.params}
          />
        )
      ) : (
        <Large data={data} params={props.match.params} />
      )}
    </div>
  )
}

ProductListPage.propTypes = {
  screenType: PropTypes.string,
  className: PropTypes.string,
  ...routerPropTypes
}

const mapStateToProps = state => ({ screenType: state.UI.screenType })

const mapDispatchToProps = dispatch => ({
  storeProductsResponse: bindActionCreators(storeProductsResponse, dispatch),
  storeLocation: bindActionCreators(storeLocation, dispatch),
  dispatch
})

export default connect(mapStateToProps, mapDispatchToProps)(ProductListPage)
